import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faGithub, faFacebook, faYoutube, faInstagram } from '@fortawesome/free-brands-svg-icons';

export default function Footer() {
    const [navbarOpen, setNavbarOpen] = useState(false);

    const handleNavLinkClick = () => {
        window.scrollTo(0, 0);
        setNavbarOpen(false);
    };
    return (
        <div className='bg-light'>
            <div className="container py-5">
                <div className="row">
                    {/* Brand Section */}
                    <div className="col-lg-8 mb-4 mb-lg-0">
                        <div className="footer-brand fw-bold fs-4 text-dark">About Uyimozhy</div>
                        <div className="text-muted mb-3">
                            പുസ്തകങ്ങൾ വഴി അറിവും സംസ്‌കാരവും പ്രചരിപ്പിക്കുന്നത് ഉയിർമൊഴിയുടെ ലക്ഷ്യം. ഉയിർമൊഴി എന്നത് മികച്ച ഗ്രന്ഥങ്ങൾ പ്രസിദ്ധീകരിക്കുന്നതിലൂടെ വായനക്കാരെ പ്രചോദിപ്പിക്കുന്നതിന് രൂപകൽപ്പന ചെയ്ത ഒരു പ്രസിദ്ധീകരണ സ്ഥാപനമാണ്. വായനയിലൂടെ നിങ്ങളുടെ അറിവും സൃഷ്ടിപരതയും വർധിക്കും.
                            2017-ല്‍ തിരുവനന്തപുരം ജില്ലയില്‍ വെഞ്ഞാറമൂട് ആസ്ഥാനമാക്കി ആരംഭിച്ച ഒരു മലയാള സാഹിത്യ പ്രവര്‍ത്തക കൂട്ടായ്മയാണ് ഉയിർമൊഴി.
                        </div>
                        <div className="d-flex gap-3">
                            <a
                                href="https://www.youtube.com/@uyirmozhi6938"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-dark fs-5"
                            >
                                <FontAwesomeIcon icon={faYoutube} />
                            </a>
                            <a
                                href="https://www.facebook.com/share/1BAgN6hTHw/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-dark fs-5"
                            >
                                <FontAwesomeIcon icon={faFacebook} />
                            </a>
                            <a
                                href="https://www.instagram.com/uyirmozhy_publications_2026"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-dark fs-5"
                            >
                                <FontAwesomeIcon icon={faInstagram} />
                            </a>
                        </div>
                    </div>

                    {/* Footer Links */}
                    <div className="col-lg-4">
                        <div className="row">
                            <div className="col-md-6 mb-4">
                                <h6 className="text-uppercase text-secondary mb-3">Explore</h6>
                                <ul className="list-unstyled">
                                    <li>
                                        <NavLink
                                            className="text-decoration-none text-dark"
                                            to="/books"
                                            onClick={handleNavLinkClick}
                                        >
                                            Books
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink
                                            className="text-decoration-none text-dark"
                                            to="/faq"
                                            onClick={handleNavLinkClick}
                                        >
                                            FAQ
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink
                                            className="text-decoration-none text-dark"
                                            to="/contact"
                                            onClick={handleNavLinkClick}
                                        >
                                            Contact Us
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink
                                            className="text-decoration-none text-dark"
                                            to="/become-publisher"
                                            onClick={handleNavLinkClick}
                                        >
                                            Become Publisher
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-md-6 mb-4">
                                <h6 className="text-uppercase text-secondary mb-3">Company</h6>
                                <ul className="list-unstyled">
                                    <li>
                                        <NavLink
                                            className="text-decoration-none text-dark"
                                            to="/about"
                                            onClick={handleNavLinkClick}
                                        >
                                            About Us
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink
                                            className="text-decoration-none text-dark"
                                            to="/privacy"
                                            onClick={handleNavLinkClick}
                                        >
                                            Privacy Policy
                                        </NavLink>
                                    </li>
                                    <li>
                                        <NavLink
                                            className="text-decoration-none text-dark"
                                            to="/t&c"
                                            onClick={handleNavLinkClick}
                                        >
                                            Terms &amp; Conditions
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom Footer */}
            <footer className="bg-dark py-3 mt-auto bg-cherry-red">
                <div className="container px-5">
                    <div className="row align-items-center justify-content-between flex-column flex-sm-row">
                        <div className="col-auto">
                            <div className="small m-0 text-white">
                                Copyright &copy; Uyirmozhy @ 2025 | Designed and developed by Raru
                            </div>
                        </div>
                        <div className="col-auto">
                            <NavLink
                                className="link-light small"
                                to="/privacy"
                                onClick={handleNavLinkClick}
                            >
                                Privacy
                            </NavLink>
                            <span className="text-white mx-1">&middot;</span>
                            <NavLink
                                className="link-light small"
                                to="/t&c"
                                onClick={handleNavLinkClick}
                            >
                                Terms
                            </NavLink>
                            <span className="text-white mx-1">&middot;</span>
                            <NavLink
                                className="link-light small"
                                to="/contact"
                                onClick={handleNavLinkClick}
                            >
                                Contact
                            </NavLink>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}
